import { ArticlePage2 } from './ArticlePage2.js';

export class ArticlePageWK6 extends ArticlePage2 {
    constructor(containerId) {
        super(containerId, {
            headline: "Taegeuk Ladies Qualify for 2027 World Cup",
            author: "footballgirl",
           date: "March, 2026",
            image: "images/wk/6a.jpg",
             content: `<article>

  <h3>South Korea Secure 2027 Women’s World Cup Qualification with Dominant Asian Cup Run</h3>

  <h3>Qualification Secured in Australia</h3>
  <p>
    The South Korea women's national football team, led by head coach Shin Sang-woo, have secured qualification for the 2027 FIFA Women’s World Cup in Brazil after reaching the semifinals of the AFC Women's Asian Cup in Australia.
  </p>
  <p>
    Their place in the final four guarantees automatic qualification, continuing South Korea’s steady presence on the global stage and confirming their status as one of Asia’s most consistent sides in women’s international football.
  </p>

  <h3>Statement Victory Over Uzbekistan</h3>
  <p>
    South Korea sealed qualification in emphatic fashion with a 6–0 victory over Uzbekistan in the quarterfinals in Sydney.
  </p>
  <p>
    The team imposed control from the outset. Forward Son Hwa-yeon opened the scoring just nine minutes into the match, setting the tone for a dominant performance. Go Yu-jin doubled the lead midway through the first half with a long-range strike.
  </p>
  <p>
    The second half saw further attacking efficiency, with goals from Park Su-jung, Ji So-yun, and Lee Eun-young. Jang Sel-gi completed the rout with a stoppage-time penalty.
  </p>
  <p>
    Ji So-yun’s goal was particularly significant, extending her record as South Korea’s all-time leading scorer in international matches to 75 goals—further cementing her legacy as one of Asia’s greatest players.
  </p>

  <h3>Building Momentum in Asia</h3>
  <p>
    This marks South Korea’s second consecutive semifinal appearance at the Asian Cup, following their runner-up finish in the 2022 edition in India. Under Shin Sang-woo, the team has shown increased tactical discipline and attacking depth, blending experienced leaders with emerging talent.
  </p>
  <p>
    Their upcoming semifinal clash against Japan will be a significant test, not only for a place in the final but also as a benchmark against one of Asia’s strongest sides.
  </p>

  <h3>Women’s World Cup History</h3>
  <p>
    Qualification for Brazil 2027 will be South Korea’s fifth appearance at the FIFA Women’s World Cup, and their fourth consecutive qualification since 2015.
  </p>
  <p>
    Their performances across previous tournaments reflect a trajectory of gradual progress:
  </p>
  <ul>
    <li><strong>2003 (USA)</strong> – Debut appearance; eliminated in the group stage</li>
    <li><strong>2015 (Canada)</strong> – Historic breakthrough; reached the Round of 16, their best-ever finish</li>
    <li><strong>2019 (France)</strong> – Group stage exit</li>
    <li><strong>2023 (Australia & New Zealand)</strong> – Group stage exit, despite competitive performances</li>
  </ul>
  <p>
    The 2015 campaign remains a landmark moment, signaling South Korea’s ability to compete beyond Asia. However, subsequent tournaments have highlighted the gap between qualification consistency and deep tournament runs.
  </p>

  <h3>Evolution of the Squad</h3>
  <p>
    South Korea’s continued qualification is rooted in a strong domestic structure and increasing investment in women’s football. The WK League has played a key role in developing talent, while more players are gaining experience abroad in Europe and other competitive environments.
  </p>
  <p>
    Under Shin Sang-woo, the team has emphasized tactical organization, high work rate, and transitional play—traits that have made them difficult opponents in tournament settings.
  </p>

  <h3>Key Players for Brazil 2027</h3>
  <p>
    As South Korea look ahead to the 2027 World Cup, several players are expected to form the core of the squad:
  </p>
  <ul>
    <li><strong>Ji So-yun</strong> – The team’s captain and creative leader; her experience and goal-scoring ability remain central</li>
    <li><strong>Jang Sel-gi</strong> – A versatile presence capable of influencing both defense and attack</li>
    <li><strong>Son Hwa-yeon</strong> – A key attacking outlet with pace and finishing ability</li>
    <li><strong>Cho So-hyun</strong> – Midfield anchor and leader, providing balance and control</li>
    <li><strong>Lee Geum-min</strong> – A dynamic forward with international experience</li>
  </ul>
  <p>
    Alongside these established names, a new generation of players is emerging, adding depth and competition within the squad.
  </p>

  <h3>Looking Ahead to Brazil</h3>
  <p>
    With qualification secured, attention now turns to preparation for Brazil 2027. South Korea’s challenge will be to translate regional consistency into global impact—moving beyond group-stage exits and re-establishing themselves as knockout-stage contenders.
  </p>
  <p>
    The foundation is in place: experienced leadership, tactical cohesion, and a growing talent pipeline. The next step is execution on the world stage.
  </p>

</article>  <h3>대한민국 여자축구, 2027 브라질 월드컵 출전권 확보</h3>

  <h3>호주에서 출전권 확보</h3>
  <p>
    신상우 감독이 이끄는 대한민국 여자축구대표팀은 호주에서 열린 AFC 여자아시안컵 4강 진출로 2027 FIFA 여자월드컵 브라질 대회 출전권을 확보했다.
  </p>
  <p>
    4강 진출로 자동 출전권을 확보하며, 한국은 국제 무대에서 꾸준한 존재감을 이어가고 있으며, 아시아에서 가장 안정적인 여자축구 팀 중 하나임을 다시 한번 확인했다.
  </p>

  <h3>우즈베키스탄전 압도적 승리</h3>
  <p>
    한국은 시드니에서 열린 8강전에서 우즈베키스탄을 6-0으로 대파하며 출전권을 확정지었다.
  </p>
  <p>
    경기 초반부터 우세를 점했다. 공격수 손화연이 경기 시작 9분 만에 선제골을 기록하며 경기를 주도했다. 고유진은 전반 중반 장거리 슛으로 2-0을 만들었다.
  </p>
  <p>
    후반에는 박수정, 지소연, 이은영이 연속 득점하며 승리를 굳혔고, 장슬기가 추가 시간 페널티킥으로 마무리했다.
  </p>
  <p>
    특히 지소연의 골은 대한민국 역대 A매치 최다 득점 기록 75골을 달성하며 아시아 최고의 선수 중 한 명으로서의 입지를 더욱 공고히 했다.
  </p>

  <h3>아시아에서의 상승세</h3>
  <p>
    이번 4강 진출은 2022년 인도 대회 준우승에 이어 두 번째 연속 아시안컵 4강 진출이다. 신상우 감독 아래 팀은 전술적 조직력과 공격 다양성을 강화하며, 경험 많은 선수와 신진 선수의 조화를 보여주고 있다.
  </p>
  <p>
    다가올 일본과의 4강전은 결승 진출뿐만 아니라 아시아 최강팀과의 실력을 가늠할 중요한 시험대가 될 것이다.
  </p>

  <h3>여자월드컵 역사</h3>
  <p>
    브라질 2027 출전은 대한민국의 FIFA 여자월드컵 5번째 출전이며, 2015년 이후 4회 연속 출전이다.
  </p>
  <p>
    이전 대회에서의 성적은 점진적인 발전의 흐름을 보여준다:
  </p>
  <ul>
    <li><strong>2003년 (미국)</strong> – 첫 출전; 조별리그 탈락</li>
    <li><strong>2015년 (캐나다)</strong> – 역사적 도약; 16강 진출, 최고 성적</li>
    <li><strong>2019년 (프랑스)</strong> – 조별리그 탈락</li>
    <li><strong>2023년 (호주 & 뉴질랜드)</strong> – 조별리그 탈락, 경쟁력 있는 경기 수행</li>
  </ul>
  <p>
    2015년 대회는 한국이 아시아를 넘어 경쟁할 수 있음을 보여준 이정표였지만, 이후 대회에서는 지속적인 출전과 본선 깊은 진출 사이의 차이를 확인할 수 있었다.
  </p>

  <h3>팀 구성의 발전</h3>
  <p>
    한국의 지속적인 월드컵 출전은 국내 구조와 여자축구에 대한 투자 증가 덕분이다. WK리그는 핵심 선수 육성에 중요한 역할을 했으며, 더 많은 선수들이 유럽 등 해외 리그 경험을 쌓고 있다.
  </p>
  <p>
    신상우 감독은 전술 조직, 높은 활동량, 전환 플레이를 강조하며, 대회에서 상대하기 까다로운 팀으로 만들고 있다.
  </p>

  <h3>브라질 2027을 위한 핵심 선수</h3>
  <p>
    2027년 월드컵을 앞두고 한국이 의존할 핵심 선수들은 다음과 같다:
  </p>
  <ul>
    <li><strong>지소연</strong> – 팀 주장, 창의적 리더; 경험과 득점 능력 핵심</li>
    <li><strong>장슬기</strong> – 수비와 공격 모두에 영향력 있는 다재다능 선수</li>
    <li><strong>손화연</strong> – 스피드와 마무리 능력을 갖춘 핵심 공격수</li>
    <li><strong>조소현</strong> – 미드필드 지휘자, 팀 균형과 조율 담당</li>
    <li><strong>이금민</strong> – 국제 경험을 갖춘 역동적 공격수</li>
  </ul>
  <p>
    이들과 함께 신진 선수들도 성장하며 팀 내 경쟁과 깊이를 더하고 있다.
  </p>

  <h3>브라질로의 전망</h3>
  <p>
    출전권 확보 이후, 브라질 2027 준비가 본격화된다. 한국의 과제는 아시아에서의 꾸준한 성과를 세계 무대에서도 이어가는 것이며, 조별리그 탈락을 넘어 본선에서 경쟁력을 발휘하는 것이다.
  </p>
  <p>
    팀은 경험 있는 리더십, 전술적 결속력, 성장하는 선수층이라는 탄탄한 기반을 갖추고 있으며, 이제 세계 무대에서 실행으로 보여줄 차례다.
  </p>
`,
            tags: ["South Korea Women’s National Team", 
                "2027 Women’s World Cup",
                "AFC Women’s Asian Cup", "Ji So-yun", 
                "Women’s Football","대한민국 여자대표팀","2027 여자월드컵",
                "AFC 여자아시안컵","지소연", "여자축구"],

               navIndices: { prev: 'wk-5', next: 'wk-7' }
        });
    }

    init() {
        console.log('ArticlePageWK6 initialized');
        super.init();
    }

    render() {
        super.render();
        
        const backBtn = this.element.querySelector('#articleBackBtn');
        if (backBtn) {
            backBtn.innerHTML = `
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="width: 16px; height: 16px; margin-right: 6px;">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                Back to WK League
            
<div style="margin:24px auto;max-width:720px;text-align:center;"><script async src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-7705230222200385" crossorigin="anonymous"></script><ins class="adsbygoogle" style="display:block;text-align:center;" data-ad-layout="in-article" data-ad-format="fluid" data-ad-client="ca-pub-7705230222200385" data-ad-slot="1708603458"></ins><script>(adsbygoogle = window.adsbygoogle || []).push({});</script></div>
`;
            
            const newBackBtn = backBtn.cloneNode(true);
            backBtn.parentNode.replaceChild(newBackBtn, backBtn);
            
            newBackBtn.addEventListener('click', (e) => {
                e.preventDefault();
                const event = new CustomEvent('navigateHome', { bubbles: true, detail: { anchor: 'wk' } });
                this.element.dispatchEvent(event);
            });
        }

        const leagueLogo = this.element.querySelector('.hero-util-btn img');
        if (leagueLogo) {
            leagueLogo.src = '/images/league_wk.png';
            leagueLogo.alt = 'WK League';
        }
    }
}